import * as actionTypes from "../ActionTypes";

// ✅ Save Leadership Language Meta
export const saveLeadershipLanguageMetaRequest = (apiPayloadRequest, callback) => ({
  type: actionTypes.SAVE_LEADERSHIP_LANGUAGE_META_REQUEST,
  payload: { apiPayloadRequest },
  callback,
});

export const saveLeadershipLanguageMetaSuccess = (data) => ({
  type: actionTypes.SAVE_LEADERSHIP_LANGUAGE_META_SUCCESS,
  payload: data,
});

export const saveLeadershipLanguageMetaFailure = (error) => ({
  type: actionTypes.SAVE_LEADERSHIP_LANGUAGE_META_FAILURE,
  payload: error,
});
